import {getCurrentCompanyUUID} from '@/utils/company'
import {reportHandledError} from '@/utils/sentry'

const STORAGE_PREFIX = 'listQueryState'

function getStorageKey(listName) {
    const companyUUID = getCurrentCompanyUUID()
    if (companyUUID === '') {
        return null
    }
    return `${STORAGE_PREFIX}:${companyUUID}:${listName}`
}

export function readListQueryState(listName) {
    const storageKey = getStorageKey(listName)
    if (storageKey == null) {
        return null
    }
    const storedValue = sessionStorage.getItem(storageKey)
    if (storedValue == null) {
        return null
    }
    try {
        return JSON.parse(storedValue)
    } catch (error) {
        reportHandledError(error, {
            module: 'list_state',
            operation: 'read_query_state',
            context: {listName: listName}
        })
        sessionStorage.removeItem(storageKey)
        return null
    }
}

export function writeListQueryState(listName, queryState) {
    const storageKey = getStorageKey(listName)
    if (storageKey == null) {
        return
    }
    sessionStorage.setItem(storageKey, JSON.stringify(queryState))
}
